var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])}
var staticRenderFns = []

export { render, staticRenderFns }